(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sherl", [], factory);
	else if(typeof exports === 'object')
		exports["sherl"] = factory();
	else
		root["sherl"] = factory();
})(self, () => {
return 